import React from 'react';
import Radio from 'apollo-react/components/Radio';

const RadioInput = ({ field, meta, label, value, onChange ,required}) => {
  return (
    <Radio
      {...field}
      label={label}
      value={value}
      checked={field.value === value}
      onChange={(e) => onChange(e.target.value)}
      error={meta.touched && !!meta.error}
      required={required}
      helperText={meta.touched && meta.error ? meta.error : ""}
    />
  );
};

export default RadioInput;
